import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const Admin = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    const isAdmin = Cookies.get('admin-auth');
    if (!isAdmin) {
      navigate('/admin-login');
    } else {
      // Redirect to Sanity Studio (configurable via env)
      const studioUrl = import.meta.env.VITE_SANITY_STUDIO_URL || 'https://andrea-villalobos.sanity.studio/';
      window.location.href = studioUrl;
    }
  }, [navigate]);

  // Show loading state while checking auth and redirecting
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="text-xl text-gray-600">
        Redirecting to Sanity Studio...
      </div>
    </div>
  );
};

export default Admin;